import React, { Component } from 'react';
import PropTypes from 'prop-types';
import styles from './Bullet.scss';
import { getMergedClassNames } from '../../utils/HTMLUtils';

const rootClassName = styles.rootClassName;

class Bullet extends Component {
  render() {
    return (
      <div
        className={getMergedClassNames([
          rootClassName,
          this.props.actived ? rootClassName + '-actived' : '',
        ])}
      ></div>
    );
  }
}

Bullet.propTypes = {
  actived: PropTypes.bool,
};

export default Bullet;
